import script from "./input.vue?vue&type=script&lang=ts&setup=true"
export * from "./input.vue?vue&type=script&lang=ts&setup=true"

import "./input.vue?vue&type=style&index=0&id=1502a73f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1502a73f"]])

export default __exports__